module.exports = __webpack_public_path__ + "img/20200415143344TIM截图20200415143102.359e55d2.png";